import { createSlice } from "@reduxjs/toolkit";
import { setLadingCachingHandler, setPortCategory, setProfileMapData, setProfileRedirectionId, setTabDetails, setUnLadingCachingHandler } from "./portProfile.action";
import { profileTabs } from "@components/templates/Profile/ProfileHeader/profile-enum";

let ladingCaching = {
  overview: {
    trade_country: null,
    trade_lane: null,
    trade_port: null,
    location: null,
  },
  freight_forwarder: null,
  vocc: null,
  nvocc: null,
  importers: null,
  profileDetails: {},
  shipmentDistribution: null,
};

let unladingCaching = {
  overview: {
    trade_country: null,
    trade_lane: null,
    trade_port: null,
    location: null,
  },
  freight_forwarder: null,
  vocc: null,
  nvocc: null,
  exporters: null,
  profileDetails: {},
  shipmentDistribution: null,
};

const portProfileSlice = createSlice({
  name: "portProfile",
  initialState: {
    countDetails: {
      loading: true,
    },
    portCategory: null,
    tabDetails: {
      activePanelId: "",
      activeTabId: profileTabs[0].id,
      mapType: "trade_lane",
    },
    profileRedirectionId: "",
    ladingCaching: { ...ladingCaching },
    unladingCaching: { ...unladingCaching },
  },
  reducers: {
    profileMapDataHandler: setProfileMapData,
    portCategoryHandler: setPortCategory,
    tabDetailsHandler: setTabDetails,
    profileRedirectionIdHandler: setProfileRedirectionId,
    ladingCachingHandler: setLadingCachingHandler,
    unLadingCachingHandler: setUnLadingCachingHandler,
  },
});

export const { profileMapDataHandler, portCategoryHandler, tabDetailsHandler, profileRedirectionIdHandler, ladingCachingHandler, unLadingCachingHandler } = portProfileSlice.actions;

export default portProfileSlice.reducer;
